var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.884 5.02976C18.5203 3.97656 15.8795 3.71565 13.3554 4.28593C10.8313 4.85621 8.55921 6.22714 6.87792 8.19424C5.19663 10.1613 4.19626 12.6192 4.02599 15.2013C3.85573 17.7834 4.5247 20.3514 5.93313 22.5222C7.34157 24.6931 9.414 26.3505 11.8413 27.2473C14.2687 28.144 16.9209 28.2321 19.4024 27.4984C21.8839 26.7647 24.0618 25.2485 25.6112 23.1759C27.1606 21.1034 27.9985 18.5855 28 15.9978V14.7719C28 14.0355 28.5969 13.4385 29.3333 13.4385C30.0697 13.4385 30.6667 14.0355 30.6667 14.7719V15.9985C30.6648 19.1613 29.6407 22.2395 27.747 24.7726C25.8533 27.3058 23.1915 29.1589 20.1585 30.0557C17.1255 30.9524 13.884 30.8447 10.9172 29.7487C7.95045 28.6526 5.41747 26.6269 3.69606 23.9736C1.97464 21.3204 1.15701 18.1818 1.36511 15.0259C1.5732 11.87 2.79588 8.86589 4.85079 6.46165C6.9057 4.05742 9.68273 2.38184 12.7677 1.68483C15.8527 0.987814 19.0804 1.30671 21.9693 2.59395C22.642 2.89365 22.9443 3.68189 22.6446 4.35452C22.3449 5.02715 21.5566 5.32946 20.884 5.02976Z",
    fill: "#54A823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2757 4.39005C30.7967 4.91049 30.7971 5.75471 30.2766 6.27567L16.9433 19.6223C16.6933 19.8726 16.3541 20.0132 16.0004 20.0133C15.6466 20.0134 15.3073 19.8729 15.0572 19.6228L11.0572 15.6228C10.5365 15.1021 10.5365 14.2579 11.0572 13.7372C11.5779 13.2165 12.4221 13.2165 12.9428 13.7372L15.9995 16.7939L28.3901 4.391C28.9105 3.87004 29.7547 3.86961 30.2757 4.39005Z",
    fill: "#54A823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.3523f0f66475474f038a6ef55ca7401e.svg";
export { ForwardRef as ReactComponent };